// Este codigo fue generado por Github Copilot Chat
import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Pipe({
  name: 'handleFormControl',
  standalone: true
})
export class HandleFormControlPipe implements PipeTransform {
  transform(formGroup: FormGroup, controlName: string): FormControl {
    return formGroup.get(controlName) as FormControl;
  }
}
// Este codigo fue generado por Github Copilot Chat
